import { MapleIconProps } from 'Components/ds/MapleIcon';
import { GITBOOK_DOCS_URL, GITBOOK_FAQ_URL, GITBOOK_TERMS_URL, isEarnEnabled } from 'Constants';

export const LEND_ROUTE = isEarnEnabled ? '/' : '/lend';
export const LEND_ROUTES = [LEND_ROUTE, '/portfolio', '/drips', '/details'];
export const STAKE_ROUTES = ['/stake'];
export const CONVERT_ROUTES = ['/convert'];

export interface NavItemProps {
  text: string;
  to: string;
  icon: MapleIconProps['icon'];
}

export interface NavConfigProps extends NavItemProps {
  description: string;
  routes: string[];
}

export const navItems: NavConfigProps[] = [
  {
    text: 'Lend',
    to: LEND_ROUTE,
    icon: 'coins',
    description: 'Deposit into SYRUP and start earning',
    routes: LEND_ROUTES,
  },
  {
    text: 'Stake',
    to: '/stake',
    icon: 'stackLine',
    description: 'Stake SYRUP and start earning yield',
    routes: STAKE_ROUTES,
  },
];

export const supportNavItems: NavItemProps[] = [
  {
    text: 'Docs',
    to: GITBOOK_DOCS_URL,
    icon: 'filePdfFill',
  },
  {
    text: 'FAQ',
    to: GITBOOK_FAQ_URL,
    icon: 'fileTextFill',
  },
  {
    text: 'Terms',
    to: GITBOOK_TERMS_URL,
    icon: 'questionFill',
  },
];
